/* eslint-disable jsx-a11y/anchor-is-valid */
import classNames from 'classnames';
import React from 'react';

import styles from './cookieBannerPanelSection.scss';

interface CookieBannerPanelSectionProps {
  children: React.ReactNode;
  isRow?: boolean;
  noMargin?: boolean;
}

const CookieBannerPanelSection = ({
  children,
  isRow = false,
  noMargin = false
}: CookieBannerPanelSectionProps) => {
  const sectionClassName = classNames(styles.wrapper, {
    [styles.isRow]: isRow,
    [styles.noMargin]: noMargin
  });
  return <div className={sectionClassName}>{children}</div>;
};

export default CookieBannerPanelSection;
